import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import socketIOClient from 'socket.io-client';

import { showMessage } from '../state/app/appActions';
import { getLatestVersion } from '../state/auth/authActions';
import { getAllCounts, getRowsAndTotal } from '../state/order/actions';
import AlertPopup from '../views/components/helpers/AlertPopup';
import Popup from '../views/components/helpers/Popup';
import ReloadPopup from '../views/components/helpers/ReloadPopup';
import navigationConfig from '../main/navigationConfig';
import consts from '../main/consts';

const ENDPOINT = consts.NOTIFICATIONS_SERVICE;
const NOTIFICATIONS_ENABLED = consts.NOTIFICATIONS_SERVICE_ENABLED;
const notificationProps = {
  autoHideDuration: null,
  anchorOrigin: {
    horizontal: 'center',
    vertical: 'bottom',
  },
};

export default function NotificationsWrapper(props) {
  const status = useSelector(state => state.orders.status);
  const { token, loja } = useSelector(state => state.auth);
  const [alert, setAlert] = React.useState({ open: false, numero: '0' });
  const [openPopup, setOpenPopup] = React.useState({ open: false, data: {} });
  const dispatch = useDispatch();

  const getMessage = (statusMessage, title) => {
    if (statusMessage === 'NOVO_PEDIDO')
      return `Chegou um pedido na página: ${title || statusMessage}!`;
    if (statusMessage === 'NOTA_FISCAL')
      return `Nota fiscal Emitida em um pedido na página: Pronto para Retirada!`;
    else
      return `Um pedido foi atualizado na página: ${title || statusMessage}!`;
  }

  React.useEffect(() => {
    dispatch(getLatestVersion());
  }, [loja, dispatch]);

  React.useEffect(() => {
    const interval = setInterval(() => {
      dispatch(getLatestVersion());
    }, consts.POOLING_VERSION_CHECK_DELAY || 60000);

    return () => {
      clearInterval(interval);
    };
  });

  React.useEffect(() => {
    dispatch(getAllCounts());
  }, [dispatch])

  React.useEffect(() => {
    if (NOTIFICATIONS_ENABLED) {
      const socket = socketIOClient(ENDPOINT);
      socket.emit('AUTHENTICATION', token, loja);

      socket.on(`PEDIDO`, (statusMessage, tipo) => {

        if (statusMessage.startsWith('AUTOMATIC_CALL_MOTOBOY')) {
          const numero = statusMessage.split(':').pop();
          setAlert({ open: true, numero });
        } else {
          const page = navigationConfig.find(nav => nav.status.includes(statusMessage)) || {};
          if (status === statusMessage) {
            const pageId = page.id;
            const filters = { status };
            pageId && dispatch(getRowsAndTotal({ pageId, filters, avoidSpinner: true }));
          }
          let variant = statusMessage === 'NOVO_PEDIDO' ? 'success' : 'warning';
          variant = statusMessage === 'NOTA_FISCAL' ? 'info' : variant;
          const message = getMessage(statusMessage, page.title);
          dispatch(showMessage(message, variant, notificationProps));
          dispatch(getAllCounts());
        }
      });

      socket.on('POPUP', data => {
           setOpenPopup({ open: true, data })
      });

      return () => socket.close();
    }
  }, [token, dispatch, status, loja]);

  return (
    <>
      <AlertPopup
        open={alert.open}
        numero={alert.numero}
        handleClose={() => setAlert({ ...alert, open: false })}
      />
      <Popup
        open={openPopup.open}
        data={openPopup.data}
        handleClose={() => setOpenPopup({ ...openPopup, open: false })}
      />
      <ReloadPopup />
      {props.children}
    </>
  );
}
